module.exports = __webpack_public_path__ + "img/mobile_payments_pre.d16d229f.png";